"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setClauseValue')(function setClauseType(clauseValue, clauseId) {
    store_1.default.inboxRulesEditState.clauseMap.get(clauseId).clauseValue = clauseValue;
});
//# sourceMappingURL=setClauseValue.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/setClauseValue.js
// module id = 3178
// module chunks = 2